module.exports = __webpack_public_path__ + "static/cover.4675f391.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/cover.png
// module id = 91
// module chunks = 168707334958949